import { useState } from 'react'
import { axiosGet } from '../util/api'

interface usePlacementAdjustmentsReturn {
    loading: boolean
    placements: Placements[]
    load: (campaign_id: number | string) => void
}

interface Placements {
    percentage: number
    placement_id: number
    placement_string: string
}

export const usePlacementAdjustments = (): usePlacementAdjustmentsReturn => {
    const [placements, setPlacements] = useState<Placements[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [campaignId, setCampaignId] = useState<number | string | null>(null)

    const load = (id: number | string): void => {
        if (id && id === campaignId) {
            // Already loaded
            return
        } else {
            setPlacements([])
        }

        setLoading(true)
        setCampaignId(id)
        axiosGet(`placements/${id}`)
            .then((res) => {
                setPlacements(res.data)
                console.log('Placements is', res.data)
                setLoading(false)
            })
            .catch(() => {
                setLoading(false)
            })
    }

    return {
        loading,
        load,
        placements,
    }
}
